<template>
  <component :is="current" v-bind="$attrs" />
</template>

<script setup>
import { useUiWrapper } from "@/utils/uiWrapper";
import FooterViewOld from "./Old/OldViewChildPopup.vue";
import NewFooterView from "./New/NewViewChildPopup.vue";

const current = useUiWrapper(FooterViewOld, NewFooterView);
</script>
